import React from 'react';
import { subscribe, publish } from '@wh/message-bus';
import { FEATURE_TYPE, LANGUAGE_ITEM_CLICKED, LANGUAGE_SELECTED } from './constants';
import { LanguageMenuRenderer } from './LanguageMenuRenderer';

export const languageMenuPlugin = {
  beforeRender({ headerRenderers, locale }) {
    headerRenderers.push({
      type: FEATURE_TYPE,
      render: ({ data }) => <LanguageMenuRenderer key={data.id} data={data} currentLocale={locale} />,
    });

    subscribe({
      topic: LANGUAGE_ITEM_CLICKED,
      callback: ({ data }) => {
        if (locale !== data.code) {
          publish(LANGUAGE_SELECTED, data.code);
        }
      },
    });
  },
};
